import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const fetchDetailDeliveryRequest = createAction(ACTION.FETCH_DETAIL_DELIVERY_REQUEST.REQUEST, (params) => params);
export const showDetailDeliveryRequest = createAction(ACTION.SHOW_DETAIL_DELIVERY_REQUEST);
export const hideDetailDeliveryRequest = createAction(ACTION.HIDE_DETAIL_DELIVERY_REQUEST);
export const clearState = createAction(ACTION.RESET_DETAIL_DELIVERY_REQUEST);